import { DEFAULT_USER_DISABLE_MEETINGS_CANCEL } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useDefaultUserDisableMeetingsCancel() {
  return useIsFeatureEnabled(DEFAULT_USER_DISABLE_MEETINGS_CANCEL);
}
